<ion-header>
  <div class="modal-header">
    <ion-toolbar>
      <div class="modal-title">
        <h3>Send Approval Request</h3>
      </div>
      <ion-buttons slot="end">
        <ion-button
          fill="clear"
          shape="round"
          class="close-button"
          (click)="dismiss()"
        >
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>

  <div style="padding: 0 15px">
    <div>
      <ion-label class="input-label">User or Group</ion-label>
      <div>
        <ion-chip
          slot="end"
          mode="ios"
          class="select-chip select-outline no-margin input-field full-width"
          [outline]="true"
          (click)="showAssigneeOptions()"
        >
          <ion-label>
            {{ assignedToName ?? "Select a user or group..." }}
          </ion-label>
        </ion-chip>
      </div>
    </div>
    <div>
      <ion-label class="input-label"> Message (optional) </ion-label>
      <ion-textarea
        slot="end"
        #markdownInput
        lines="8"
        autoGrow="true"
        placeholder="e.g. Hey can you take a look at this?"
        [(ngModel)]="title"
        class="input-field"
      >
      </ion-textarea>
    </div>
  </div>
  <div style="margin: 15px">
    <ion-button
      [disabled]="isLoading || !assignedToName"
      (click)="submit()"
      size="block"
      class="no-margin"
    >
      Send
      <ion-spinner
        name="crescent"
        [hidden]="!isLoading"
        style="margin-left: 10px"
      ></ion-spinner>
      <ion-icon
        name="arrow-forward-outline"
        class="icon-padded-left button-icon"
        [hidden]="isLoading"
      ></ion-icon>
    </ion-button>
  </div>
</ion-header>
